
export {ClayLinkContext} from '../../../frontend-js-clay-web/__liferay__/exports/@clayui$link.js';
import __x__ from '../../../frontend-js-clay-web/__liferay__/exports/@clayui$link.js';export default __x__;